import { Ship, Mail, Phone, MapPin } from "lucide-react";
import { NavLink } from "@/components/NavLink";

export const Footer = () => {
  return (
    <footer className="bg-maritime-dark text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Ship className="h-6 w-6 text-accent" />
              <span className="text-lg font-bold">Costal Meridian</span>
            </div>
            <p className="text-sm text-primary-foreground/80 mb-4">
              Your trusted global logistics partner. Headquartered in Costa Mesa, California, we deliver world-class shipping, warehousing, and supply chain solutions across 120+ partner ports worldwide.
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 text-accent mt-0.5 flex-shrink-0" />
                <span>555 Anton Blvd suite 1050, Costa Mesa, CA 92626</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-accent" />
                <span>(714) 798-3650</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-accent" />
                <span>support@costalmeridian.com</span>
              </div>
            </div>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><NavLink to="/ocean-freight" className="hover:text-accent transition-colors">Ocean Freight</NavLink></li>
              <li><NavLink to="/air-freight" className="hover:text-accent transition-colors">Air Freight</NavLink></li>
              <li><NavLink to="/customs-brokerage" className="hover:text-accent transition-colors">Customs Brokerage</NavLink></li>
              <li><NavLink to="/warehousing" className="hover:text-accent transition-colors">Warehousing</NavLink></li>
              <li><NavLink to="/intermodal" className="hover:text-accent transition-colors">Intermodal Transport</NavLink></li>
              <li><NavLink to="/project-cargo" className="hover:text-accent transition-colors">Project Cargo</NavLink></li>
              <li><NavLink to="/insurance" className="hover:text-accent transition-colors">Cargo Insurance</NavLink></li>
              <li><NavLink to="/supply-chain" className="hover:text-accent transition-colors">Supply Chain</NavLink></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><NavLink to="/tracking" className="hover:text-accent transition-colors">Track Shipment</NavLink></li>
              <li><NavLink to="/faq" className="hover:text-accent transition-colors">FAQ</NavLink></li>
              <li><NavLink to="/reviews" className="hover:text-accent transition-colors">Client Reviews</NavLink></li>
              <li><NavLink to="/sustainability" className="hover:text-accent transition-colors">Sustainability</NavLink></li>
              <li><NavLink to="/about" className="hover:text-accent transition-colors">About Us</NavLink></li>
              <li><NavLink to="/contact" className="hover:text-accent transition-colors">Contact</NavLink></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><NavLink to="/privacy-policy" className="hover:text-accent transition-colors">Privacy Policy</NavLink></li>
              <li><NavLink to="/terms-conditions" className="hover:text-accent transition-colors">Terms & Conditions</NavLink></li>
              <li><NavLink to="/cookie-policy" className="hover:text-accent transition-colors">Cookie Policy</NavLink></li>
              <li><NavLink to="/cancellation-policy" className="hover:text-accent transition-colors">Cancellation Policy</NavLink></li>
            </ul>
            <div className="mt-6 pt-6 border-t border-primary-foreground/20">
              <p className="text-xs text-primary-foreground/60">
                © 2026 Costal Meridian. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};